import { getGatedIdacBackendUrl } from '../utilities/env';
import {
  Action,
  RecoveryTsvErrorCode,
  ThunkAction,
  TsvRecoveryFieldError,
  UiError,
} from '../types';
import { AnalyticsClient } from '../utilities/analytics/analytics-web-client';

export interface RecoveryParams {
  username: string;
  password: string;
  location: Location;
  pageId: string;
  analyticsClient: AnalyticsClient;
}

type RecoveryResponse = {
  fieldErrors?: TsvRecoveryFieldError;
  formError?: String[];
  uiErrors?: UiError[];
  redirectTo?: string;
};

export const reset = (): Action => ({
  type: 'TSV_RECOVERY_RESET',
});

export const requestRecoveryLinkRedirect = (redirectTo: string): Action => ({
  type: 'TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT',
  redirectTo,
});

export const recoveryRequestFailed = (error: RecoveryTsvErrorCode): Action => ({
  type: 'TSV_RECOVERY_REQUEST_FAILED',
  error,
});

export const showFieldErrors = (error: TsvRecoveryFieldError): Action => ({
  type: 'TSV_RECOVERY_SHOW_FIELD_ERRORS',
  error,
});

export const loginRecovery =
  ({ location, password, pageId, analyticsClient }: RecoveryParams): ThunkAction =>
  (dispatch, getState) => {
    const { csrfToken } = getState();
    dispatch(reset());
    const path = getGatedIdacBackendUrl(`/2step/recover${location.search}`);
    return fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify({ password: password }),
    })
      .then(res => res.json())
      .then(({ fieldErrors, uiErrors, redirectTo }: RecoveryResponse) => {
        if (redirectTo) {
          dispatch(requestRecoveryLinkRedirect(redirectTo));
        } else {
          if (fieldErrors && Object.keys(fieldErrors).length) {
            dispatch(showFieldErrors(fieldErrors));
          } else if (uiErrors && uiErrors.length) {
            const uiError = uiErrors[0];
            if (uiError.key === 'password') {
              analyticsClient.errorShownEvent(pageId, '2svRecoveryIncorrectPassword');
            } else {
              analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
            }
            dispatch(recoveryRequestFailed(uiError.error));
          }
        }
      })
      .catch(() => {
        analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
        dispatch(recoveryRequestFailed('unknown'));
      });
  };
